import { SET_CURRENT_LANGUAGE } from 'redux/types'

const setCurrentLanguage = (payload) => {
  return { type: SET_CURRENT_LANGUAGE, payload }
}

export {
    setCurrentLanguage
}